import styled from "@emotion/styled";
import { space } from "@smartsheet/design-tokens";
import { sizes } from "../../../constants/spacing";
import { getButtonLoadingStyles } from "../styled/getButtonLoadingStyles";
import { mapButtonAppearance } from "../styled/mapButtonAppearance";
const iconWrapperMinWidths = {
  xsmall: space.space40,
  small: space.space45,
  medium: space.space45,
  large: space.space50
};
const singleIconMargin = {
  xsmall: space.space05,
  small: space.space05,
  medium: space.space10,
  large: space.space20
};
const iconsOnlyInsideMargin = {
  xsmall: -1,
  small: 1,
  medium: 2,
  large: 2
};
const getIconWrapperMargin = _ref => {
  let {
    size,
    appearance,
    hasLeftIcon,
    hasOnlyIcons,
    hasRightIcon,
    themeMode
  } = _ref;
  const isSingleIcon = hasOnlyIcons && (hasLeftIcon && !hasRightIcon || !hasLeftIcon && hasRightIcon);
  const actualAppearance = mapButtonAppearance(appearance, themeMode);
  switch (actualAppearance) {
    // For Lodestar buttons.
    case "borderless":
    case "primary":
    case "secondary":
    case "destructive":
    case "secondary-destructive":
    case "share":
      if (isSingleIcon) {
        return `calc(${singleIconMargin[size]} - 1px) var(--sds--button--padding-x-icon--${size}, calc(${singleIconMargin[size]} - 1px))`;
      } else {
        return `0 var(--sds--button--padding-x-icon--${size}, ${(size === "large" ? sizes.xSmall : sizes.xxSmall) - 1}px)`;
      }
  }
};
export const IconWrapper = styled("div")`
    position: relative;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 0;
    font-size: 0;
    user-select: none;
    //iconAfter wrappers should NOT have a minwidth, so chevron buttons in dropdowns, split buttons, etc. can be thinner
    //note that design guidance for chevron buttons is that they should be smaller at each size
    //than normal icons at each button size
    min-width: ${_ref2 => {
  let {
    size,
    iconLocation
  } = _ref2;
  return iconLocation === "before" ? iconWrapperMinWidths[size] : "none";
}};

    // Lodestar buttons - inner margin overrides for double icons with no text
    margin: ${_ref3 => {
  let {
    size,
    appearance,
    iconLocation,
    hasLeftIcon,
    hasOnlyIcons,
    hasRightIcon,
    isSplit,
    themeMode
  } = _ref3;
  if (isSplit) return 0;
  return getIconWrapperMargin({
    size,
    appearance,
    iconLocation,
    hasLeftIcon,
    hasOnlyIcons,
    hasRightIcon,
    themeMode
  });
}};
    margin-left: ${_ref4 => {
  let {
    hasLeftIcon,
    hasOnlyIcons,
    iconLocation,
    size,
    isSplit
  } = _ref4;
  return hasLeftIcon && hasOnlyIcons && iconLocation === "after" && !isSplit ? `${iconsOnlyInsideMargin[size]}px` : null;
}};
    margin-right: ${_ref5 => {
  let {
    hasRightIcon,
    hasOnlyIcons,
    iconLocation,
    size,
    isSplit
  } = _ref5;
  return hasRightIcon && hasOnlyIcons && iconLocation === "before" && !isSplit ? `${iconsOnlyInsideMargin[size]}px` : null;
}};

    ${_ref6 => {
  let {
    isLoading
  } = _ref6;
  return getButtonLoadingStyles(isLoading);
}}
`;
//# sourceMappingURL=IconWrapper.js.map